<template>
  <v-container
    v-if="ioReportItems && ioReportItems.length > 0"
    fluid
    class="IoReport pa-0 mb-3"
  >
    <v-layout row class="ListHeader my-3">
      <v-col xs2 class="subheading mx-1"></v-col>
      <v-col xs2 class="subheading mx-1">{{$t("IOReportDetailsList.emission")}}</v-col>
      <v-col xs2 class="subheading mx-1">{{$t("IOReportDetailsList.code")}}</v-col>
      <v-col xs2 class="subheading mx-1">{{$t("IOReportDetailsList.mm")}}</v-col>
      <v-col xs2 class="subheading mx-1">{{$t("IOReportDetailsList.programed")}}</v-col>
      <v-col xs2 class="subheading mx-1">{{$t("IOReportDetailsList.start")}}</v-col>
    </v-layout>
    <v-layout
      v-for="item in parsedIoItems"
      :key="title + locationName + '_io' + item.id"
      row
      class="ListItem"
      :class="{Active: (selectedIOReport && selectedIOReport.id === item.id)}"
      @click="selectIOReport(item)"
    >
      <v-col xs2 class="subheading ma-1">
        <IOReportIcon :ioDoc="item.doc" />
      </v-col>
      <v-col xs2 class="subheading ma-1">{{item.emission}}</v-col>
      <v-col xs2 class="subheading ma-1">{{item.code}}</v-col>
      <v-col xs2 class="subheading ma-1">{{item.millimeters}} {{$t("IOReportDetailsList.mmUnit")}}</v-col>
      <v-col xs2 class="subheading ma-1">{{item.start_end}}</v-col>
      <v-col xs2 class="subheading ma-1">{{item.start}}</v-col>
    </v-layout>
  </v-container>
</template>

<script>
import IOReportIcon from './IOReportIcon'

export default {
  data () {
    return {
      selectedIOReport: null
    }
  },
  components: {
    IOReportIcon
  },
  props: ['ioReportItems', 'title', 'locationName'],
  computed: {
    parsedIoItems () {
      return this.ioReportItems.map(item => {
        const result = {
          id: item.id,
          code: item.code,
          doc: item.doc && parseInt(item.doc),
          transmitter: item.transmitter,
          millimeters: item.millimeters && parseFloat(item.millimeters),
          application_rate: item.application_rate && parseFloat(item.application_rate),
          passes: item.passes && parseFloat(item.passes),
          raw_start: item.start,
          csvData: item.csvData
        }

        const getLittleDate = (date) => {
          return new Date(date).toLocaleDateString('es-ES', {month: 'numeric', day: 'numeric'})
        }
        result.emission = getLittleDate(item.emission_date)

        result.start_end = `${getLittleDate(item.start)} - ${getLittleDate(item.end)}`

        const auxOpt = {month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'}
        result.start = new Date(item.start).toLocaleDateString('es-ES', auxOpt)

        return result
      }).sort((a, b) => {
        if (a.raw_start < b.raw_start) {
          return -1
        }
        return 0
      })
    }
  },
  methods: {
    selectIOReport (ioReport) {
      if (this.selectedIOReport && this.selectedIOReport.id === ioReport.id) {
        this.selectedIOReport = null
        this.$emit('update:selectedIOReport', null)
      } else {
        this.selectedIOReport = ioReport
        this.$emit('update:selectedIOReport', ioReport)
      }
    }
  },
  beforeDestroy () {
    this.$emit('update:selectedIOReport', null)
  }
}
</script>


// WEBPACK FOOTER //
// IOReportDetailsList.vue?5dd88d9c